import { render, staticRenderFns } from "./CourseHome.vue?vue&type=template&id=02918983&scoped=true&"
import script from "./CourseHome.vue?vue&type=script&lang=js&"
export * from "./CourseHome.vue?vue&type=script&lang=js&"
import style0 from "./CourseHome.vue?vue&type=style&index=0&id=02918983&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02918983",
  null
  
)

export default component.exports